import { PaymentSchedule } from 'typescript/constants/enums/payment';

export const paymentOptionFixture = (overrides = null) => {
  const name = overrides?.name || PaymentSchedule.UPFRONT;

  const defaults = {
    name,
    selected: false,
    token: 'token',
    ineligibility_reasons: null,
    number_payment_periods: null,
    price: {
      amount: '100.00',
      currency_code: 'USD',
    },
  };

  return { ...defaults, ...overrides };
};
